import { useState } from "react";
import { X } from "lucide-react";
import FileUpload from "@/components/churchbuilder/FileUpload";
import { inp, lbl } from "./ListingForm";

const BLANK = {
  eyebrow: "", title: "", description: "", image_url: "", image_position: "center",
  cta_label: "Explore", cta_url: "", secondary_label: "", secondary_url: "", listing_id: null, order: 0, is_active: true,
};
const TEXT = [
  ["eyebrow", "Small label (e.g. HOH Studio)"], ["cta_label", "Button label"], ["cta_url", "Button link (/page or https://…)"],
  ["secondary_label", "Second button label (optional)"], ["secondary_url", "Second button link"],
];

export default function SlideForm({ initial, listings, catNames = {}, onSave, onClose }) {
  const [f, setF] = useState({ ...BLANK, ...initial });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const prefill = (id) => {
    const l = listings.find((x) => x.id === id);
    if (!l) return setF({ ...f, listing_id: null });
    setF({ ...f, listing_id: l.id, eyebrow: catNames[l.category] || l.category, title: l.title, description: l.description,
      image_url: (l.image_url || "").replace(/([?&])w=1200\b/, "$1w=1920"),
      cta_label: l.cta_label || "Explore", cta_url: l.destination_url });
  };
  const submit = (e) => { e.preventDefault(); if (!f.image_url) return; onSave({ ...f, order: Number(f.order) || 0 }); };

  return (
    <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-start justify-center overflow-y-auto p-4" data-testid="mkt-slide-form">
      <form onSubmit={submit} className="w-full max-w-3xl bg-[#111] border border-white/10 rounded-xl p-6 lg:p-8 my-10">
        <div className="flex justify-between items-center mb-6">
          <h3 className="font-serif-display text-3xl text-white">{f.id ? "Edit slide" : "New slide"}</h3>
          <button type="button" onClick={onClose} aria-label="Close" data-testid="mkt-slide-form-close" className="text-neutral-400 hover:text-white"><X size={20} /></button>
        </div>
        <div className="grid md:grid-cols-2 gap-4">
          <div className="md:col-span-2">
            <label className={lbl}>Start from a marketplace listing (optional)</label>
            <select data-testid="mkt-slide-prefill" className={inp} value={f.listing_id || ""} onChange={(e) => prefill(e.target.value)}>
              <option value="">— Write my own —</option>
              {listings.map((l) => <option key={l.id} value={l.id}>{l.title}</option>)}
            </select>
          </div>
          <div className="md:col-span-2"><label className={lbl}>Title *</label><input required data-testid="mkt-slide-title" className={inp} value={f.title} onChange={set("title")} /></div>
          <div className="md:col-span-2"><label className={lbl}>Short description</label><textarea rows={2} data-testid="mkt-slide-description" className={inp} value={f.description} onChange={set("description")} /></div>
          {TEXT.map(([k, l]) => (
            <div key={k}><label className={lbl}>{l}</label><input data-testid={`mkt-slide-${k}`} className={inp} value={f[k] || ""} onChange={set(k)} /></div>
          ))}
          <div>
            <label className={lbl}>Image focus (keeps the subject visible on phones)</label>
            <select data-testid="mkt-slide-image-position" className={inp} value={f.image_position} onChange={set("image_position")}>
              {["center", "left", "right", "top", "bottom"].map((p) => <option key={p} value={p}>{p}</option>)}
            </select>
          </div>
          <div className="md:col-span-2">
            <FileUpload value={f.image_url} onChange={(url) => setF({ ...f, image_url: url })} label="Slide image * (16:9, 1920×1080)" testid="mkt-slide-image" />
            <input data-testid="mkt-slide-image-url" placeholder="…or paste an image URL" className={`${inp} mt-2`} value={f.image_url} onChange={set("image_url")} />
            {!f.image_url && <p className="text-[11px] text-amber-300 mt-1">An image is required.</p>}
          </div>
          <label className="flex items-center gap-2 text-sm text-neutral-300">
            <input type="checkbox" data-testid="mkt-slide-active" checked={f.is_active} onChange={set("is_active")} className="accent-[#D4AF37]" /> Show this slide
          </label>
        </div>
        <div className="flex justify-end gap-3 mt-8">
          <button type="button" onClick={onClose} className="px-5 py-2.5 rounded text-xs tracking-widest uppercase text-neutral-300 border border-white/15 hover:border-white/40">Cancel</button>
          <button type="submit" disabled={!f.image_url} data-testid="mkt-slide-save" className="btn-gold px-6 py-2.5 rounded text-xs tracking-widest uppercase font-semibold disabled:opacity-50">Save slide</button>
        </div>
      </form>
    </div>
  );
}
